import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SettingToken } from '@sleed/bizcommerce-api';
import { settingsApi } from '~/lib/api/client';
import { formToToken, type SettingFormValues } from '~/lib/schemas/setting';

/** Param group that scopes the loyalty-points settings (legacy `getallbyparamgroup?key=LoyaltyPoints`). */
export const LOYALTY_PARAM_GROUP = 'LoyaltyPoints';

export const loyaltySettingKeys = {
	all: ['loyalty-settings'] as const,
	list: () => [...loyaltySettingKeys.all, 'list'] as const
};

/** Loyalty-points settings (the `LoyaltyPoints` param group only). */
export function useLoyaltySettingsList() {
	return useQuery<SettingToken[]>({
		queryKey: loyaltySettingKeys.list(),
		queryFn: async () => (await settingsApi.getAllByParamGroup(LOYALTY_PARAM_GROUP)).data.items ?? []
	});
}

/** Update / delete a loyalty setting (the legacy grid is edit + delete, no add). */
export function useLoyaltySettingMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: loyaltySettingKeys.all });
	const update = useMutation({
		mutationFn: async (form: SettingFormValues) => (await settingsApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({
		mutationFn: async (id: number) => (await settingsApi.remove(id)).data,
		onSuccess: invalidate
	});
	return { update, remove };
}
